module.exports = __webpack_public_path__ + "b323ca02349313c8b732252f6bcd00b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/gamecenter/tw/phoenixwar.jpg
// module id = 635
// module chunks = 30